var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon-button',_vm._g({attrs:{"title":_vm.title}},_vm.$listeners),[_c('base-material-design-icon',{attrs:{"icon":"add"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }